import { useState } from 'react';
import classNames from 'classnames';

function ChoiceBottomModel({ selectedData, setModelBottom }) {
	const [activeIndex, setActiveIndex] = useState(0);

	const handleModelSelection = (item, itemIndex) => {
		setActiveIndex(itemIndex);
		setModelBottom(() => item);
	}

	if (!selectedData) {
		return null;
	}

	return (
		<div className="choices">
			<ul>
				{selectedData.parts.bottom.list.map((item, index) => (
					<li key={index}>
						<a
							onClick={(e) => {
								e.preventDefault();
								handleModelSelection(item, index)
							}}
							className={classNames('preview decor-checkbox', { 'is-active': activeIndex === index })}
							href={item.model}
						>
							<picture className="preview__media">
								<img src={item.preview} alt={item.name} />
							</picture>

							<div className="preview__content">
								<h6>{item.name}</h6>
							</div>
						</a>
					</li>
				))}
			</ul >
		</div >
	);
}

export default ChoiceBottomModel;